var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("ModalGestionBarquettes", {
        ref: "gestionBarquette",
        on: {
          refreshBarquette: function($event) {
            return _vm.chargerBarquettes()
          }
        }
      }),
      _c("BarreActions", {
        attrs: { actions: _vm.actions },
        on: {
          "appliquer-action": function($event) {
            return _vm.executerAction($event)
          }
        }
      }),
      _c("div", { staticClass: "card table-scroll height-responsive-100" }, [
        _vm._m(0),
        _c("div", { staticClass: "table-body" }, [
          _c(
            "table",
            { staticClass: "table table-bordered table-sm text-center" },
            [
              _vm._m(1),
              _c(
                "tbody",
                [
                  _vm._l(_vm.listeBarquettes, function(barquette, iBarquette) {
                    return [
                      _c(
                        "tr",
                        {
                          key: iBarquette,
                          class: [
                            {
                              "ligne-selectionnee":
                                barquette.id === _vm.idBarquetteSelectionnee
                            },
                            { "ligne-desactivee": !barquette.active }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.selectionnerBarquette(barquette)
                            }
                          }
                        },
                        [
                          _c("td", { staticClass: "aligner-gauche" }, [
                            _vm._v(_vm._s(barquette.designation))
                          ]),
                          _c("td", { staticClass: "aligner-gauche" }, [
                            _vm._v(_vm._s(barquette.taille))
                          ]),
                          _c("td", [
                            barquette.active
                              ? _c("i", {
                                  staticClass: "fas fa-check",
                                  staticStyle: {
                                    "margin-right": "2px",
                                    "vertical-align": "middle"
                                  },
                                  attrs: { title: "Barquette active" }
                                })
                              : _vm._e()
                          ])
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      { staticClass: "table table-bordered table-sm text-center table-header" },
      [
        _c("colgroup", [
          _c("col"),
          _c("col", { attrs: { width: "200" } }),
          _c("col", { attrs: { width: "80" } })
        ]),
        _c("thead", [
          _c("th", { staticClass: "aligner-gauche" }, [_vm._v("Designation")]),
          _c("th", [_vm._v("Taille (Nombre de portions)")]),
          _c("th", [_vm._v("Active")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _c("col", { attrs: { width: "200" } }),
      _c("col", { attrs: { width: "75" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }